// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorParentCatalog = (client) => ({
    /**
     * `POST /vendor/parent-catalog/children/:childProductId/compliance-flags`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorParentCatalogChildComplianceFlagsCreate
     * @source packages/modules/b2c-core/src/api/vendor/parent-catalog/children/[childProductId]/compliance-flags/route.ts
     */
    createChildrenComplianceFlag: (childProductId, body, query, headers) => client.fetch(buildPath("/vendor/parent-catalog/children/:childProductId/compliance-flags", [childProductId]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/parent-catalog/children`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorParentCatalogChildrenList
     * @source packages/modules/b2c-core/src/api/vendor/parent-catalog/children/route.ts
     */
    retrieveChildren: (query, headers) => client.fetch("/vendor/parent-catalog/children", { method: "GET", query, headers }),
    /**
     * `GET /vendor/parent-catalog/children/:childProductId/audit`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorParentCatalogChildAuditRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/parent-catalog/children/[childProductId]/audit/route.ts
     */
    retrieveChildrenAudit: (childProductId, query, headers) => client.fetch(buildPath("/vendor/parent-catalog/children/:childProductId/audit", [childProductId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/parent-catalog/compliance-flags/:id/escalate`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorParentCatalogComplianceFlagsEscalateCreate
     * @source packages/modules/b2c-core/src/api/vendor/parent-catalog/compliance-flags/[id]/escalate/route.ts
     */
    updateComplianceFlagsEscalate: (id, body, query, headers) => client.fetch(buildPath("/vendor/parent-catalog/compliance-flags/:id/escalate", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/parent-catalog/compliance-flags/:id/resolve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorParentCatalogComplianceFlagsResolveCreate
     * @source packages/modules/b2c-core/src/api/vendor/parent-catalog/compliance-flags/[id]/resolve/route.ts
     */
    updateComplianceFlagsResolve: (id, body, query, headers) => client.fetch(buildPath("/vendor/parent-catalog/compliance-flags/:id/resolve", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=parent-catalog.js.map